import type { AccoDetails } from '@/scopes/products/pages/components/DestinationSection/types';
import type { AccoDetailsAPIResponse } from './types';
import { parseSitecoreFloat } from '@/scopes/products/domain/utils';

export interface AccoDetailsResponseMapper {
  map: (data: AccoDetailsAPIResponse) => AccoDetails;
}

export const createAccoDetailsResponseMapper = (): AccoDetailsResponseMapper => {
  function map(data: AccoDetailsAPIResponse): AccoDetails {
    return {
      city: data.breadcrumbs[2].text,
      region: data.breadcrumbs[1].text,
      country: data.breadcrumbs[0].text,
      imageUrl: data.image.resolvedSrc.split('?')[0],
      name: data.titleText,
      rating: parseSitecoreFloat(data.rating),
      url: data.titleUrl,
      userRating: data.grade?.length ? parseSitecoreFloat(data.grade) : 0,
    };
  }

  return { map };
};
